class HeroContainer extends HTMLElement {
  constructor() {
    super();

    this.mainHeaders = document.querySelectorAll("[data-main-header]");
    const lightTheme =
      document.body.hasAttribute("data-theme") &&
      document.body.getAttribute("data-theme") === "light";
  }

  connectedCallback() {
    this.heroResize();
  }

  heroResize() {
    if (this.lightTheme) {
      this.mainHeaders.forEach((mainHeader) => {
        if (mainHeader.hasAttribute("data-main-header")) {
          if (window.matchMedia("(max-width: 1024px)").matches) {
            this.querySelector(".container--wrapper").style.top =
              mainHeader.offsetHeight + "px";
          }
          this.style.height = "calc(400px + " + mainHeader.offsetHeight + "px)";
        }
      });
    }
  }
}

customElements.define("hero-container", HeroContainer);
